const clock = (minutes) =>
  `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;

/** The half-hour appointment slots from 09:00 to 18:30, as "HH:MM - HH:MM". */
export const TIME_SLOTS = Array.from(
  { length: 19 },
  (_, i) => `${clock(540 + i * 30)} - ${clock(570 + i * 30)}`
);
